import React, { Children } from "react"
import cx from "classnames"
import { Icon, IconColorsType, IconSources } from "../Icon"

const ICON_SIZE = 20
export interface PillPropsType {
  children: React.ReactNode
  icon?: IconSources
  color?: IconColorsType
  size?: "large"
  overlayed?: boolean
  className?: string
}

export const Pill = ({
  icon,
  color = "onSurface",
  children,
  overlayed,
  className,
  size,
}: PillPropsType) => {
  const iconMarkup = icon ? (
    <span className="cobalt-Pill__Icon">
      <Icon
        source={icon}
        size={ICON_SIZE}
        color={overlayed ? "surfaceFixed" : color}
      />
    </span>
  ) : null

  return (
    <div
      className={cx(className, "cobalt-Pill", {
        "cobalt-Pill--colorConnect": color === "connect",
        "cobalt-Pill--overlayed": overlayed,
        "cobalt-Pill--large": size === "large",
      })}
    >
      {iconMarkup} {children}
    </div>
  )
}

export interface PillGroupPropsType {
  children: React.ReactNode
}

export const PillGroup = ({ children }: PillGroupPropsType) => {
  return (
    <div className="cobalt-PillGroup">
      {Children.toArray(children).map((child, index) => (
        <div className="cobalt-PillGroup__Item" key={index}>
          {child}
        </div>
      ))}
    </div>
  )
}

export default Pill
